export default __webpack_public_path__ + "static/media/4b4a0d7793aaf8bb1561c5b9e47b6e84.svg";